<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">info</span>
      <h2>Introduction</h2>
    </div>

    <p class="section-intro">
      Le <strong>SGI ABIAPHAR Distribution</strong> (Système de Gestion Intégrée)
      est une application web conçue pour gérer l'ensemble des opérations
      commerciales et logistiques de la société ABIAPHAR Distribution. Ce système
      couvre toute la chaîne de valeur : de l'approvisionnement (importation de
      conteneurs) à la vente au client final, en passant par la gestion des
      stocks, la comptabilité et les statistiques.
    </p>

    <h3 class="sub-title">Objectifs du système</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Objectif</th><th>Description détaillée</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Centraliser</strong></td><td>Regrouper toutes les données commerciales, financières et logistiques dans un seul outil accessible en ligne.</td></tr>
          <tr><td><strong>Automatiser</strong></td><td>Automatiser les processus de gestion des stocks (entrées, sorties, inventaires), des commandes et des paiements pour réduire les erreurs humaines.</td></tr>
          <tr><td><strong>Tracer</strong></td><td>Conserver un historique complet et horodaté de toutes les opérations : qui fait quoi, quand, et avec quel montant.</td></tr>
          <tr><td><strong>Contrôler</strong></td><td>Gérer les accès selon les rôles de chaque utilisateur (Administrateur, Caisse, Magasinier, etc.) pour que chacun ne voie que ce qui le concerne.</td></tr>
          <tr><td><strong>Analyser</strong></td><td>Fournir des statistiques et rapports exportables (Excel) pour piloter l'activité : chiffre d'affaires, bénéfices, mouvements de stock, etc.</td></tr>
        </tbody>
      </table>
    </div>

    <h3 class="sub-title">Prérequis techniques</h3>
    <div class="info-card info">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#5b9bd5">computer</span>
        Configuration recommandée
      </div>
      <p>
        <strong>Navigateur :</strong> Google Chrome, Mozilla Firefox ou Microsoft Edge (version récente).<br>
        <strong>Connexion :</strong> Internet stable.<br>
        <strong>Écran :</strong> Résolution minimum de 1280 × 720 pixels.<br>
        <strong>Périphériques :</strong> Souris et clavier.
      </p>
    </div>

    <h3 class="sub-title">Comment accéder au système</h3>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p><strong>Ouvrir le navigateur</strong> — Lancez Google Chrome (recommandé) ou Firefox.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p><strong>Saisir l'adresse</strong> — Tapez l'adresse du système dans la barre d'adresse (fournie par votre administrateur).</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p><strong>Page de connexion</strong> — Vous arrivez sur la page de connexion. Saisissez votre email et votre mot de passe (voir section « Connexion »).</p>
      </div>
    </div>
  </div>
</template>
<script>
export default { name: "DocIntroduction" };
</script>
